import { v4 as uuidv4 } from 'uuid';
import areaInSquareFeet from '../api/areaInSquareFeet';
import {
  updateStairsPrice,
  updateStairsPadPrice,
  UPDATE_STEPS,
  EDIT_STEPS,
  CONFIRM_STEPS,
  ADD_STEPS,
  QUESTION_ANSWERED,
} from './actionCreators';
import { trackStaircaseNumber } from '../utils/analytics/trackEvents';

export const updateSteps = (steps, selectedCarpetPrice, sqFtArea = undefined) => (dispatch) => {
  const id = uuidv4();
  const length = steps * 2;
  const width = 3;
  const rollWidth = 12;
  if (!sqFtArea) {
    areaInSquareFeet(id, length, width, rollWidth)
      .then((data) => {
        // if (steps && steps !== 0) {
        trackStaircaseNumber(steps);
        // }

        dispatch({
          type: UPDATE_STEPS,
          payload: {
            stepsId: id,
            steps,
            stairsSquareFeet: data.areaInSquareFeet,
            price: selectedCarpetPrice || 0,
            stairsSquarePrice: parseFloat(((data.areaInSquareFeet / 9) * selectedCarpetPrice).toFixed(2), 2),
          },
        });
      });
  }
  // bypass api call if area in url
  dispatch({
    type: UPDATE_STEPS,
    payload: {
      stepsId: id,
      steps,
      stairsSquareFeet: sqFtArea,
      price: selectedCarpetPrice || 0,
      stairsSquarePrice: parseFloat(((sqFtArea / 9) * selectedCarpetPrice).toFixed(2), 2),
    },
  });
};

export const updateStepPrice = (selectedprice) => (dispatch) => {
  dispatch(updateStairsPrice(selectedprice));
};

export const updateStepPadPrice = (padPrice) => (dispatch) => {
  dispatch(updateStairsPadPrice(padPrice));
};

export const addSteps = (isAdd) => (dispatch) => {
  dispatch({
    type: ADD_STEPS,
    payload: isAdd,
  });
};

export const editSteps = (isEdit) => (dispatch) => {
  dispatch({
    type: EDIT_STEPS,
    payload: isEdit,
  });
};

export const confirmSteps = (isConfirmed) => (dispatch) => {
  dispatch({
    type: CONFIRM_STEPS,
    payload: isConfirmed,
  });
};

export const questionAnswered = (fulfilled) => (dispatch) => {
  dispatch({
    type: QUESTION_ANSWERED,
    payload: fulfilled,
  });
};
